import 'css-chunk:src/applications/ProductFulfillmentApp/NoCatalogueProductSelection/containers/ProjectConfigSetupContainer/ProjectConfigSetupContainer.styles.scss';export default {
  "ProjectConfigSetupContainer": "_ProjectConfigSetupContainer_mtr6x_1",
  "content": "_content_mtr6x_5",
  "setup": "_setup_mtr6x_9",
  "preview": "_preview_mtr6x_13"
};